export type DevelopmentMapLocation = {
  id: string;
  name: string;
  location: string;
  lat: number;
  lng: number;
};

export const DEVELOPMENT_MAP_LOCATIONS: DevelopmentMapLocation[] = [
  {
    id: 'broomfield',
    name: 'Broomfield House',
    location: 'Chelmsford',
    lat: 51.77204893221734,
    lng: 0.4632351891885133,
  },
  {
    id: 'southlands',
    name: 'Southlands House',
    location: 'Sittingbourne',
    lat: 51.35038219687165,
    lng: 0.6895121590041949,
  },
  {
    id: 'whitstable-heights',
    name: 'Whitstable Heights',
    location: 'Whitstable',
    lat: 51.34133484086814,
    lng: 1.0126344958176652,
  },
  {
    id: 'pembury',
    name: 'Pembury House',
    location: 'Tunbridge Wells',
    lat: 51.142393700413905,
    lng: 0.31377821312690485,
  },
  {
    id: 'bishopswood',
    name: 'Bishopswood House',
    location: 'Basingstoke',
    lat: 51.349432491800734,
    lng: -1.1567421894091052,
  },
  {
    id: 'harpwood',
    name: 'Harpwood House',
    location: 'Sevenoaks',
    lat: 51.297971890215564,
    lng: 0.345225693460603,
  },
  {
    id: 'whitstable-phase-1',
    name: 'Whitstable House',
    location: 'Whitstable',
    lat: 51.34133484086814,
    lng: 1.0126344958176652,
  },
  {
    id: 'rodwell',
    name: 'Rodwell House',
    location: 'Addlestone',
    lat: 51.35673466845552,
    lng: -0.5145485740647904,
  },
];

export function getDevelopmentMapLocation(id: string): DevelopmentMapLocation | undefined {
  return DEVELOPMENT_MAP_LOCATIONS.find((entry) => entry.id === id);
}
